import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import httpClient from "../../utils/httpClient";
import { ApiStatus } from "../../utils/apiStatus.enum";

export const getAppConfigurations = createAsyncThunk<
  any,
  void,
  {
    rejectValue: { message: string };
  }
>("AppConfigurationSlice/getAppConfigurations", async (_, thunkApi) => {
  try {
    const response = await httpClient.get("/config");
    if (
      response.status != 200 ||
      response.data.Status?.toLowerCase() != "success"
    ) {
      if (response.data.Status?.toLowerCase() == "error") {
        return thunkApi.rejectWithValue({
          message: response.data.Message,
        });
      } else {
        return thunkApi.rejectWithValue({
          message: "Failed to get app configurations.",
        });
      }
    }
    if (response.data) {
      return response.data;
    }
    return thunkApi.rejectWithValue({
      message: "Failed to get app configurations.",
    });
  } catch (error) {
    console.log("🚀 ~ error:", error);
    return thunkApi.rejectWithValue({
      message: "Failed to get app configurations.",
    });
  }
});

export interface AppConfigurations {
  [key: string]: {
    ConfigValue: number | string | boolean; // int / string / boolean based on the configuration
    Description: string;
    ValueType: string;
    Category: string;
  };
}

interface AppConfigurationState {
  configurations: AppConfigurations;
  configApiStatus: ApiStatus;
  configApiError: string;
}

const initialState: AppConfigurationState = {
  configurations: {},
  configApiStatus: ApiStatus.NONE,
  configApiError: "",
};

const AppConfigurationSlice = createSlice({
  name: "appConfiguration",
  initialState,
  reducers: {
    resetAppConfiguration: (state) => {
      state.configurations = {};
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAppConfigurations.pending, (state) => {
      state.configApiStatus = ApiStatus.LOADING;
    });
    builder.addCase(getAppConfigurations.rejected, (state, { payload }) => {
      state.configApiError = payload?.message.toString() || "";
      state.configApiStatus = ApiStatus.ERROR;
    });
    builder.addCase(getAppConfigurations.fulfilled, (state, { payload }) => {
      state.configurations = payload.Data || {};
      state.configApiStatus = ApiStatus.SUCCESS;
    });
  },
});

export const { resetAppConfiguration } = AppConfigurationSlice.actions;
export default AppConfigurationSlice.reducer;
